import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../../services/http-request/http-request.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialog } from '../dialog/models/dialog.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicFormControl, InputType, DynamicFormControlType, TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { SYSTEM_CONST } from '../../constants/system-constants.model';
import { DialogService } from '../../services/dialog/dialog.service';
import { IBulkImport, IFileMode, responseType } from '../../constants/import-export-dialog.enum';
import { ImportExportService } from '../../services/import-export/import-export.service';

@Component({
  selector: 'app-import-export-dialog',
  standalone: true,
  imports: [DialogComponent],
  templateUrl: './import-export-dialog.component.html'
})
export class ImportExportDialogComponent implements OnInit, OnDestroy {
  private httpRequestService = inject(HttpRequestService);
  dialogRef = inject<MatDialogRef<ImportExportDialogComponent>>(MatDialogRef);
  private translation = inject(TranslationService);
  private fileService = inject(ImportExportService);
  private dialogService = inject(DialogService);
  data = inject(MAT_DIALOG_DATA);

  onDialogClose$: Subject<void> = new Subject<void>();
  uploadForm: FormGroup = new FormGroup({
    file: new FormControl(null, Validators.required)
  });
  formConfig: IDialog;
  showDialog: boolean = false;

  ngOnInit() {
    const formControls = this.data.formControls ? this.data.formControls : { controls: this.getFileUploadConfig() };
    const form = this.data.form ? this.data.form : this.uploadForm;
    this.formConfig = {
      formControls: formControls,
      form: form,
      title: this.data.title,
      dialogButton: {
        saveButtonConfig: { title: this.translation.instant('FORM_FIELD.SAVE'), showButton: true },
        cancelButtonConfig: { title: this.translation.instant('COMMON.CANCEL'), showButton: true },
      },
      useSubject: true,
      fileType: this.data.fileType
    };
    this.showDialog = true;
    this.dialogListner();
  }

  dialogListner() {
    this.dialogService.formValue.pipe(takeUntil(this.onDialogClose$)).subscribe(result => {
      if (result && result.event == 'save') {
        if (this.data.header)
          this.data.API = `${this.data.API}/${result.data[this.data.header]}`;
        else if (this.data.queryParams) {
          let str = '';
          this.data.queryParams.forEach(res => {
            str = str + `${res} = ${result.data[res]}`;
          });
          this.data.API = this.data.API + '?' + str;
        }
        this.data.mode == IFileMode.download ? this.fileService.downloadExcelFile(this.data.API, this.data.fileName, this.dialogRef) : this.bulkImport(result.data);
      }
    });
  }

  bulkImport(data: object) {
    const formData: FormData = new FormData();
    formData.append('file', data['file']);
    const header = new HttpHeaders({});
    this.httpRequestService.post(this.data.API, formData, null, header).subscribe({
      next: (resp: IBulkImport) => {
        this.dialogRef.close(resp.status ? responseType.success : resp);
        this.fileService.importExportCustomMessage(resp.status, (resp.status == 0) ? resp.error : resp.message);
      },
      error: (errorResp: HttpErrorResponse) => {
        this.uploadForm.reset();
        if (errorResp.error?.errors?.file?.length > 0)
          this.fileService.importExportCustomMessage(-1, errorResp.error.errors.file[0]);
      }
    });
  }

  getFileUploadConfig(): DynamicFormControl[] {
    return [
      {
        control: {
          label: 'File',
          formControlName: 'file',
          appearance: SYSTEM_CONST.OUTLINE,
          type: InputType.text,
        },
        type: DynamicFormControlType.FileUpload,
        isRequired: true
      }
    ];
  }

  unSubscribeDialog() {
    this.onDialogClose$.next();
    this.onDialogClose$.complete();
  }

  ngOnDestroy() {
    this.unSubscribeDialog();
  }
}
